export default __webpack_public_path__ + "static/media/a038-7.c21db75d.svg";